import React, {useEffect, useState} from "react";
import Modal from 'react-bootstrap/Modal';
import { useLocation } from "@reach/router"
import Cookies from 'universal-cookie';

import 'bootstrap/scss/bootstrap.scss'
import "../scss/global.scss";
import "../scss/grunticon.scss"
import "../scss/custom.scss";
import "slick-carousel/slick/slick.css";
import "../scss/myaccount.scss"

import $ from 'jquery'

import Header from "./Header/Header";
import Footer from "./Footer/Footer"
import ChatWidget from "./ChatWidget/ChatWidget";
import SEO from "../common/seo";
import { GlobalStateProvider } from './GlobalState/GlobalStateProvider';
import {RenderComponent} from "../modules/render-component";

import { isAuthenticated, doRedirect, storeData } from "@starberry/myaccount-website-utils";


const Layout = (props) => {

  const renderComponent = RenderComponent()

  const cookies = new Cookies();

  var { hash, href } = useLocation()
  const authuser = isAuthenticated()

  const [state, setState] = React.useState({
    showMenu: false
  })
  const [show, setShow] = useState(false);
  const [initialLoad, setInitialLoad] = useState(false);
  const handleClose = () => { setShow(false); setInitialLoad(false)}
  const handleShow = () => setShow(true);
  const [loginUser, setLoginUser] = useState(false);

  useEffect(() => {
    //console.log("authuser useeff", authuser, loginUser);
    setLoginUser(authuser)
  }, [authuser])

  const handlerClick = () => {
    setState({ ...state, showMenu: !state.showMenu })
  }

  const handleScroll = () => {
    const position = typeof window !== "undefined" && window.pageYOffset;
    //setScrollPosition(position);
    var div_pos = $(".login_section").next("section").offset().top + 50;
    //console.log("div_pos ==>", div_pos, position)

    if(position < (parseInt(div_pos) - 300)){
      setShow(false);
      setInitialLoad(true)
    }

    if(position > parseInt(div_pos)){
      //console.log("div_pos", parseInt(div_pos), position)
      setShow(true);
    }

  };

  const loginInvestment = (e) => {
    e.preventDefault();
    //console.log("auth_return ==>", href)
    storeData('auth_return', href)
    doRedirect(process.env.GATSBY_MYACCOUNT_URL)
  }

  useEffect(() => {
    let get_ot_cookie = cookies?.get('OptanonConsent')
    let split_cookie = get_ot_cookie?.split("&");

    if(split_cookie?.length > 0 && split_cookie?.includes('AwaitingReconsent=false')){
      $("#onetrust-consent-sdk").css("display","none");
    }


    $("#onetrust-accept-btn-handler, #onetrust-reject-all-handler, #onetrust-close-btn-container, .ot-pc-refuse-all-handler, .save-preference-btn-handler").on('click', function(){
      $("#onetrust-consent-sdk").css("display","none");
    })

    //console.log("OptanonConsent", split_cookie.includes('AwaitingReconsent=false'))

  },[cookies])

  useEffect(() => {

    //$(`${hash}`).css("scroll-marigin-top", "100px")
    //console.log("pathname", hash)

    if(props?.menu_slug === "investment-centre" || props?.menu_slug === "investments"){

      if(!authuser){
        //setInitialLoad(true)
        window.addEventListener('scroll', handleScroll, { passive: false });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
      }
    }

    if(hash){
      //console.log("hash ==>", hash)
      setTimeout(() => {
        $('html, body').scrollTop($(hash).offset().top - 250);
      }, 200)
    }


  }, [])

  useEffect(() => {
    //console.log("showMenu", state.showMenu)
    if (state.showMenu) {
      $("body").addClass("overflow_hidden")
    } else {
      $("body").removeClass("overflow_hidden")
    }

  }, [state.showMenu])



  // React.useEffect(() => {
  //   $(window).scrollTop(0);
  //   console.log("scroll_top")
  // }, [props])


  //console.log("authuser", authuser, loginUser);
  
  var main_container_div = `main_container ${authuser} ${loginUser} ${props?.menu_slug ? props.menu_slug.replace(/-/g, '_')+"_cls" : ""} ${props?.GQLPage?.layout} ${props?.GQLPage?.page_class}`
  // if(!loginUser){
  //     console.log("authuser 1", authuser, loginUser);

  //     main_container_div = `main_container no_auth ${props?.menu_slug ? props.menu_slug.replace(/-/g, '_')+"_cls" : ""} ${props?.GQLPage?.layout} ${props?.GQLPage?.page_class}`
  // }

  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (state.showMenu) {
      setIsClosing(false);
    } else {
      setIsClosing(true);
      const timeout = setTimeout(() => {
        setIsClosing(false);
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [state.showMenu]);

  return (
    <>
      
      {!props?.dynamicSEO &&
        <SEO title={props?.seo_meta?.title} description={props?.seo_meta?.description} image={props?.seo_meta?.image?.url} />
      }
      <GlobalStateProvider>
        {(process.env.GATSBY_SITE_NAME === "Charters") && 
          <ChatWidget />
        }
        <div className={main_container_div}>
          <div className={`${state.showMenu ? "header_cnt open-search-block" : "header_cnt"}${isClosing ? " closing" : ""}`}>
            <Header showMenu={state.showMenu} handlerClick={handlerClick} stickyHeader={props.stickyHeader}  GQLPage={props.GQLPage} currency={props?.currency}/>
          </div> 

            {props.children}

          <Footer isJourneySec={props.isJourneySec} menu_slug={props.menu_slug} searchParams={props.searchParams} popular_search={props.popular_search} footerCls={props.footerCls} GQLPage={props.GQLPage} /> 
        </div>
      </GlobalStateProvider>

      {initialLoad && 
      <Modal 
        className="login_popup"
        show={show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Register or sign in to access this content</Modal.Title>
        </Modal.Header>
        <Modal.Body>Propertycloud gives you early access to exclusive investment opportunities before they hit the market.</Modal.Body>
        <Modal.Footer>
          <a href={"javascript:;"} className="btn" onClick={(e) => loginInvestment(e)}>Login</a>
          <a href={"javascript:;"} onClick={handleClose} className="btn">Cancel</a>
        </Modal.Footer>
      </Modal>
      }
    </>

  )
}


export default Layout;
